const PRO_URL = "https://api.kabbie.com.au/";

const DEV_URL = "https://api.kabbie.com.au/";

const PRO_API_URL = PRO_URL + "api/";

const DEV_API_URL = DEV_URL + "api/";

export const URL = process.env.NODE_ENV === "production" ? PRO_URL : DEV_URL;

export const API_URL =
  process.env.NODE_ENV === "production" ? PRO_API_URL : DEV_API_URL;
